import ApiService from '../service/ApiServiceFetch';

let moduleApi = {};
let moduleName = "MapApi";

moduleApi.searchByLngLat = (lnglatTitude, access_token) => {
    let objData = {
        method: "GET",
        url: "https://api.mapbox.com/geocoding/v5/mapbox.places/" + lnglatTitude.long + ',' + lnglatTitude.lat + ".json",
        params: { access_token: access_token },
        type: "",
        message: {
            success: "",
            error: "",
        },
    };
    return ApiService(objData);
}
export default moduleApi;